import { Col, Row } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';

import { BORDER_MAIN, COUNT_DAY_IN_WEEK, COUNT_WEEK, FORMAT_DATE, WIDTH_COLUMN_CALENDAR_TIME } from '../const';
import { getCustomWeekNumber, getItemsDataForWeek, getSetOfWeekDateByDate, getStartOfWeek } from '../functions';
import { RootState } from '../store';
import { ItemType } from '../types';
import CalendarContentDay from './calendarContentDay';
import CalendarGridColumnWeek from './calendarGridColumnWeek';

const CalendarGridMonth = () => {
    const filteredItems = useSelector<RootState, ItemType[]>((state) => state.calendar.filteredItems);
    const availableHeight = useSelector<RootState, number>((state) => state.calendar.availableHeight);

    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);

    const dayStartMonth = DateTime.fromISO(currentDate).startOf('month');
    const weekNumber = getCustomWeekNumber(dayStartMonth);
    const dayStartWeek = getStartOfWeek(dayStartMonth);

    const getContentDay = (
        indexWeek: number,
        itemsDataByWeekDay: (ItemType | null)[][],
        currentDayStartWeek: DateTime,
    ) => {
        return Array.from({ length: COUNT_DAY_IN_WEEK }).map((_, indexDayWeek) => {
            return (
                <CalendarContentDay
                    key={indexWeek}
                    indexDayWeek={indexDayWeek}
                    currentDayStartWeek={currentDayStartWeek}
                    dayStartWeek={dayStartWeek}
                    indexWeek={indexWeek}
                    itemsDataByWeekDay={itemsDataByWeekDay}
                />
            );
        });
    };

    return (
        <>
            {Array.from({ length: COUNT_WEEK }).map((_, indexWeek) => {
                const currentDayStartWeek = dayStartWeek.plus({
                    days: indexWeek * COUNT_DAY_IN_WEEK,
                });

                const setOfDaysWeek = getSetOfWeekDateByDate(currentDayStartWeek.toFormat(FORMAT_DATE));
                const newItemsDataByWeekDay = getItemsDataForWeek(setOfDaysWeek, filteredItems);

                return (
                    <Row key={indexWeek} style={{ height: availableHeight / COUNT_WEEK }}>
                        <Col
                            style={{
                                borderRight: BORDER_MAIN,
                                width: WIDTH_COLUMN_CALENDAR_TIME,
                                textAlign: 'center',
                            }}
                        >
                            <label style={{ color: 'grey' }}>{weekNumber + indexWeek}</label>
                        </Col>
                        <Col
                            style={{
                                width: `calc(100% - ${WIDTH_COLUMN_CALENDAR_TIME}px)`,
                                position: 'relative',
                            }}
                        >
                            <CalendarGridColumnWeek
                                countColumn={COUNT_DAY_IN_WEEK}
                                rowHeight={availableHeight / COUNT_WEEK}
                                children={getContentDay(indexWeek, newItemsDataByWeekDay, currentDayStartWeek)}
                            />
                        </Col>
                    </Row>
                );
            })}
        </>
    );
};

export default React.memo(CalendarGridMonth);
